module.exports = __webpack_public_path__ + "img/bars.c109ca4f.svg";